import {
    UPDATE_RESTAURANT_ACTIVITY_PERIODS
} from '../types';
import api from '../api';

export const updateActivityPeriods = (restId, hours, onSuccess) => {
    return {
        type: UPDATE_RESTAURANT_ACTIVITY_PERIODS,
        payload: api.restaurant.get(restId).openingHours.update(hours),
        meta: { restId, onSuccess }
    };
};
